import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import axios from 'axios';
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../css/Ind-details.css"; // Import the separate CSS file
import Navbar from "./Navbar";
import TitleBar from "./TitleBar";
import Footer from "./Footer";
import { BaseUrl } from "../Services/Api";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import FileUploadIcon from '@mui/icons-material/FileUpload';

const OverAllPIPReport = (props) => {
  const { data, image } = props;
  const [filterText, setFilterText] = useState("");
  const [userDetails, setUserDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate=useNavigate();

  // pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  useEffect(() => {
     document.title = 'Report';
    axios
      .get(`${BaseUrl}/over-all-pip-report`, {
        withCredentials: true, // 👈 ensures cookies are sent
      })
      .then((response) => {
        const data = Object.values(response.data);
        setUserDetails(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1 + (currentPage - 1) * perPage,
      sortable: false,
      width: "80px",
    },
    {
      name: "OCP ID",
      selector: (row) => row.ocp_cer_id,
      sortable: true,
      cell: (row) => <div className="email-cell">{row.ocp_cer_id}</div>,
    },
     {
      name: "Fullname",
      selector: (row) => row.fullname,
      sortable: true,
      cell: (row) => <div className="name-cell">{row.fullname}</div>,
    }, 
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => <div className="email-cell">{row.email}</div>,
    },
    {
      name: "Mobile",
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => <div className="email-cell">{row.phone}</div>,
    },
    {
      name: "Programme Name",
      selector: (row) => row.param2,
      sortable: true,
      cell: (row) => <div className="programme-cell">{row.course_name}</div>,
    },
    {
      name: "View",
      cell: (row) => (
       <FontAwesomeIcon
  icon={faEye}
  style={{ cursor: "pointer", color: "#007bff" }}
  onClick={() =>
    navigate(`/report`, { state: { rowData: row.id } })
  }
/>

      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "80px",
    },
    // {
    //   name: "Transaction Number",
    //   selector: (row) => row.transaction_id,
    //   sortable: true,
    //   cell: (row) => (
    //     <div className="transaction-cell">{row.transaction_id}</div>
    //   ),
    // },
    // {
    //   name: "UTR Number",
    //   selector: (row) => row.utr_number,
    //   sortable: true,
    //   cell: (row) => <div className="utr-cell">{row.utr_number}</div>,
    // },
  
    // {
    //   name: "Date",
    //   selector: (row) => row.time_of_approval,
    //   sortable: true,
    //   cell: (row) => (
    //     <div className="date-cell">
    //       {new Date(row.time_of_approval).toLocaleDateString()}
    //     </div>
    //   ),
    // },
  ];

const filteredData = userDetails.filter((item, index) => {
  return (
    (index + 1).toString().includes(filterText) ||
    (item.ocp_cer_id && item.ocp_cer_id.toLowerCase().includes(filterText.toLowerCase())) ||
    (item.fullname && item.fullname.toLowerCase().includes(filterText.toLowerCase())) ||
    (item.email && item.email.toLowerCase().includes(filterText.toLowerCase())) ||
    (item.phone && item.phone.toString().includes(filterText)) || // <-- number handled
    (item.course_name && item.course_name.toLowerCase().includes(filterText.toLowerCase()))
  );
});


  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredData.map((item, index) => ({
        "S.No": index + 1,
        "OCP ID": item.ocp_cer_id,
        "Fullname": item.fullname,
        "Email": item.email,
        "Programme Name": item.param2,
        "Transaction Number": item.transaction_id,
        "UTR Number": item.utr_number,
        Date: new Date(item.time_of_approval).toLocaleDateString(),
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, "user_data.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("OCP User Details", 14, 10);

    const tableColumn = [
      "S.No",
      "OCP ID",
      "Fullname",
      "Email",
      "Programme Name",
      "Date",
    ];
    const tableRows = filteredData.map((user, index) => [
      index + 1,
      user.ocp_cer_id,
      user.fullname,
      user.email,
      user.param2,
      new Date(user.time_of_approval).toLocaleDateString(),
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      headStyles: {
        fillColor: "#ABBAF6",
        textColor: "#000000",
        fontStyle: "bold",
      },
      styles: {
        cellPadding: 3,
        fontSize: 8,
        valign: "middle",
      },
    });

    doc.save("user_data.pdf");
  };

  return (
    <>
      <Navbar />
      <TitleBar title={data} image={image} />
      <div className="user-table-container">
        <div className="user-table-header">
          <div className="user-table-controls">
            <div className="user-table-search">
              <input
                type="text"
                placeholder="Search by name, email, programme, transaction or UTR..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                className="user-search-input"
              />
            </div>

            <div className="user-table-export">
              <button
                onClick={exportToExcel}
                className="export-btn export-excel"
              >
                <span><FileUploadIcon style={{ marginRight: '-2px', marginLeft: '-5px' }} />Export to Excel</span>
              </button>
              <button onClick={exportToPDF} className="export-btn export-pdf">
                <span><FileUploadIcon style={{ marginRight: '-2px', marginLeft: '-5px' }} />Export to PDF</span>
              </button>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Loading user data...</p>
          </div>
        ) : (
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            striped
            paginationServer={false} // local pagination
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage, page) => {
              setPerPage(newPerPage);
              setCurrentPage(page);
            }}
            customStyles={{
              head: {
                style: {
                  fontSize: "15px",
                },
              },
              headRow: {
                style: {
                  backgroundColor: "#ABBAF6",
                  borderTop: "1px solid #e0e0e0",
                  borderBottom: "1px solid #e0e0e0",
                },
              },
              headCells: {
                style: {
                  fontWeight: "600",
                  color: "#2c3e50",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                },
              },
              cells: {
                style: {
                  paddingLeft: "12px",
                  paddingRight: "12px",
                },
              },
              rows: {
                style: {
                  fontSize: "14px",
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                },
                stripedStyle: {
                  backgroundColor: "#f8fafc",
                },
              },
              pagination: {
                style: {
                  borderTop: "none",
                },
              },
            }}
          />
        )}
      </div>
      <Footer />
    </>
  );
};

export default OverAllPIPReport;
